import React, { useEffect, useState } from 'react';
import Layout from '../../components/layout/Layout';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { postData } from '../../services/apiService';
import SecurityIcon from "@mui/icons-material/Security";
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Divider, Grid, Paper, Stack, TextField, Typography, useTheme, useMediaQuery, Alert, Snackbar, CircularProgress } from "@mui/material";

const Payment = () => {
    const theme = useTheme();
    const isMedium = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const navigate = useNavigate();
    // const { cartData, totalAmount } = location.state || { cartData: [], totalAmount: 0 };
    const { cartData } = location.state || { cartData: [], totalAmount: 0 };

    const [paymentDetails, setPaymentDetails] = useState([]);
    const [orderSummary, setOrderSummary] = useState({
        totalStudents: 0,
        courseFee: 0,
        gst: 0,
        totalAmount: 0,
    });
    const [couponCode, setCouponCode] = useState('');
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showError, setShowError] = useState(false);
    const [processingPayment, setProcessingPayment] = useState(false);

    useEffect(() => {
        if (cartData && cartData.length > 0) {
            // const totalCourseFee = cartData.reduce((sum, item) => sum + (parseFloat(item.course?.amount) || 0), 0);
            // const gstAmount = totalCourseFee * cartData[0]?.course?.tax;
            // const finalTotalAmount = totalCourseFee + gstAmount;

            const totalCourseFee = cartData.reduce((sum, item) => sum + (parseFloat(item.course?.amount) || 0), 0);
                const taxRate = parseFloat(cartData[0]?.course?.tax) / 100 || 0; // Convert percentage to decimal
                console.log('taxRate', taxRate);
                console.log('totalCourseFee', totalCourseFee);
                const gstAmount = totalCourseFee * taxRate;
                const finalTotalAmount = totalCourseFee + gstAmount;

            setPaymentDetails(cartData);
            setOrderSummary({
                totalStudents: cartData.length,
                courseFee: totalCourseFee,
                gst: gstAmount,
                totalAmount: finalTotalAmount,
            });
        }
    }, [cartData]);


    const handleApplyCoupon = async () => {
        if (!couponCode.trim()) {
            setError('Please enter a coupon code');
            setShowError(true);
            return;
        }

        setLoading(true);
        try {
            const response = await postData('/vouchers/verify', {
                code: couponCode,
                course_id: paymentDetails[0]?.course?._id,
                college_id: paymentDetails[0]?.college?._id,
                total_uses: cartData.length
            });

            if (response.success) {
                setAppliedCoupon(response.data);
                setOrderSummary(prev => ({
                    ...prev,
                    courseFee: 0,
                    gst: 0,
                    totalAmount: 0
                }));
                setError('');
                setShowError(false);
            }
        } catch (error) {
            setError(error.response?.data?.error || 'Failed to verify coupon');
            setShowError(true);
        } finally {
            setLoading(false);
        }
    };

    // Remove the coupon
    const handleRemoveCoupon = async () => {
        if (!appliedCoupon) return;

        setLoading(true);
        try {
            await postData('/vouchers/remove', {
                code: appliedCoupon.code,
                course_id: paymentDetails[0]?.course?._id,
                college_id: paymentDetails[0]?.college?._id,
                total_uses: cartData.length
            });

            setAppliedCoupon(null);
            setCouponCode('');
            if (cartData && cartData.length > 0) {
                // const totalCourseFee = cartData.reduce((sum, item) => sum + (parseFloat(item.course?.amount) || 0), 0);
                // const gstAmount = totalCourseFee * cartData[0]?.course?.tax;
                // const finalTotalAmount = totalCourseFee + gstAmount;

                const totalCourseFee = cartData.reduce((sum, item) => sum + (parseFloat(item.course?.amount) || 0), 0);
                const taxRate = parseFloat(cartData[0]?.course?.tax) / 100 || 0; // Convert percentage to decimal
                console.log('taxRate', taxRate);
                console.log('totalCourseFee', totalCourseFee);
                const gstAmount = totalCourseFee * taxRate;
                const finalTotalAmount = totalCourseFee + gstAmount;

                setOrderSummary({
                    totalStudents: cartData.length,
                    courseFee: totalCourseFee,
                    gst: gstAmount,
                    totalAmount: finalTotalAmount,
                });
            }
            setError('');
            setShowError(false);
        } catch (error) {
            setError(error.response?.data?.error || 'Failed to remove coupon');
            setShowError(true);
        } finally {
            setLoading(false);
        }
    };

    const handlePayment = async () => {
        if (!paymentDetails.length) {
            setError('No payment details available');
            setShowError(true);
            return;
        }

        setProcessingPayment(true);
        try {
            // Create order
            const orderResponse = await postData('/payments/create-order', {
                amount: orderSummary.totalAmount,
                course_id: paymentDetails[0]?.course?._id,
                college_id: paymentDetails[0]?.college_id?._id,
                student_ids: paymentDetails.map(item => item.studentOrInstitut?._id),
                voucher_id: appliedCoupon?._id
            });

            if (!orderResponse.success) {
                throw new Error(orderResponse.error || 'Failed to create order');
            }

            // Handle zero amount payment (when voucher covers entire amount)
            if (orderResponse.data.isZeroAmount) {
                // Payment successful
                navigate('/payment-success', {
                    state: {
                        transactionId: orderResponse.data.transactionId,
                        courseName: paymentDetails[0]?.course?.courseName,
                        amount: orderSummary.totalAmount
                    }
                });
                return;
            }

            const { orderId, amount, currency, transactionId } = orderResponse.data;

            // Initialize Razorpay
            const options = {
                key: process.env.REACT_APP_RAZORPAY_KEY_ID,
                amount: amount,
                currency: currency,
                name: "SE-LMS",
                description: `Payment for ${paymentDetails[0]?.course?.courseName}`,
                order_id: orderId,
                handler: async function (response) {
                    try {
                        // Verify payment
                        const verifyResponse = await postData('/payments/verify', {
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                            transactionId
                        });

                        if (verifyResponse.success) {
                            // Payment successful
                            navigate('/payment-success', {
                                state: {
                                    transactionId,
                                    courseName: paymentDetails[0]?.course?.courseName,
                                    amount: orderSummary.totalAmount
                                }
                            });
                        } else {
                            throw new Error(verifyResponse.error || 'Payment verification failed');
                        }
                    } catch (error) {
                        setError(error.message || 'Payment verification failed');
                        setShowError(true);
                    }
                },
                prefill: {
                    name: paymentDetails[0]?.student?.firstName + ' ' + paymentDetails[0]?.student?.lastName,
                    email: paymentDetails[0]?.student?.email,
                },
                theme: {
                    color: "#1976d2"
                }
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();
        } catch (error) {
            setError(error.message || 'Failed to initiate payment');
            setShowError(true);
        } finally {
            setProcessingPayment(false);
        }
    };

    return (
        <Layout>
            <Box className="p-6 bg-gray-100 min-h-screen">
                <Snackbar open={showError} autoHideDuration={6000} onClose={() => setShowError(false)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }} >
                    <Alert onClose={() => setShowError(false)} severity="error" sx={{ width: '100%' }}>
                        {error}
                    </Alert>
                </Snackbar>
                <Box sx={{ p: { xs: 2, sm: 3 }, bgcolor: "white", borderRadius: "10px", width: "100%" }}>
                    <Box
                        sx={{
                            display: "flex", flexDirection: { xs: 'column', sm: 'row' },
                            justifyContent: "space-between", alignItems: { xs: 'flex-start', sm: 'center' }, mb: 3,
                        }} >
                        <Typography variant="h6" component="h1" sx={{ mb: { xs: 2, sm: 0 } }}>
                            Payment Details
                        </Typography>
                        <Button variant="contained" color="primary" startIcon={<ArrowBackIcon />}
                            sx={{
                                borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                                '&:hover': { backgroundColor: '#3A3897' },
                            }}
                            onClick={() => navigate(-1)}>
                            Back
                        </Button>
                    </Box>

                    <Grid container spacing={2}>
                        {/* Left section - Course details */}
                        <Grid item xs={12} md={isMedium ? 12 : 7}>
                            <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, height: "100%", border: "1px solid #dadada", borderRadius: "10px", }}>
                                <Box>
                                    <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, justifyContent: "space-between", mb: 2 }}>
                                        <Box sx={{ maxWidth: { xs: "100%", sm: "60%" }, mb: { xs: 2, sm: 0 } }}>
                                            <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
                                                {paymentDetails[0]?.course?.courseName || 'N/A'}
                                            </Typography>
                                        </Box>
                                        <Box component="img"
                                            src={paymentDetails[0]?.course?.thumbnail || 'https://via.placeholder.com/267x138'}
                                            alt={paymentDetails[0]?.course?.courseName || 'Course Image'}
                                            sx={{
                                                width: { xs: "100%", sm: "267px" }, height: { xs: "auto", sm: "138px" }, objectFit: "cover", borderRadius: "10px",
                                            }} />
                                    </Box>

                                    <Stack spacing={1} sx={{ mt: 2 }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Course Code : {paymentDetails[0]?.course?.code || 'N/A'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Description : {paymentDetails[0]?.course?.description || 'N/A'}
                                        </Typography>
                                    </Stack>
                                </Box>
                            </Paper>
                        </Grid>

                        {/* Right section - Order summary */}
                        <Grid item xs={12} md={isMedium ? 12 : 5}>
                            <Paper elevation={0} sx={{ p: { xs: 2, sm: 3 }, height: "100%", border: "1px solid #dadada", borderRadius: "10px", }}>
                                <Typography variant="h6" gutterBottom>
                                    Order Summary
                                </Typography>

                                <Stack spacing={2}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="body1" color="text.secondary">
                                            Total Students
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            {orderSummary.totalStudents}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="body1" color="text.secondary">
                                            Course Fee
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            Rs {orderSummary.courseFee.toLocaleString()}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="body1" color="text.secondary">
                                            Tax ({paymentDetails[0]?.course?.tax}%)
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary">
                                            Rs {orderSummary.gst.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>

                                    <Divider sx={{ my: 1 }} />

                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography variant="body1" fontWeight="medium">
                                            Total Amount
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary" fontWeight="medium" >
                                            Rs {orderSummary.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                </Stack>

                                <Box sx={{ mt: 4 }}>
                                    <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                                        Apply Coupon
                                    </Typography>

                                    {appliedCoupon ? (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                            <Typography variant="body2" color="success.main">
                                                Coupon applied: {appliedCoupon.code}
                                            </Typography>
                                            <Button size="small" color="error" onClick={handleRemoveCoupon}>
                                                Remove
                                            </Button>
                                        </Box>
                                    ) : (
                                        <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: 1, mt: 1 }}>
                                            <TextField
                                                placeholder="Apply Coupon" variant="outlined" size="small" fullWidth
                                                value={couponCode} onChange={(e) => setCouponCode(e.target.value)} disabled={loading} />
                                            <Button variant="contained" color="primary"
                                                sx={{
                                                    borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                                                    '&:hover': { backgroundColor: '#3A3897' },
                                                }} onClick={handleApplyCoupon} disabled={loading} >
                                                {loading ? 'Applying...' : 'Apply'}
                                            </Button>
                                        </Box>
                                    )}

                                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            sx={{
                                                borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                                                '&:hover': { backgroundColor: '#3A3897' },
                                            }}
                                            onClick={handlePayment}
                                            disabled={processingPayment}
                                        >
                                            {processingPayment ? (
                                                <>
                                                    <CircularProgress size={24} color="inherit" sx={{ mr: 1 }} />
                                                    Processing...
                                                </>
                                            ) : (
                                                'Pay Now'
                                            )}
                                        </Button>
                                    </Box>

                                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", mt: 3, gap: 1, flexWrap: 'wrap', }}>
                                        <SecurityIcon fontSize="small" color="action" />
                                        <Typography variant="caption" color="text.secondary">
                                            Secure payments
                                        </Typography>
                                        <CreditCardIcon fontSize="small" color="action" />
                                        <AssignmentReturnIcon fontSize="small" color="action" />
                                    </Box>
                                </Box>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Layout>
    );
};

export default Payment;